export var SETTER_ACTIONS;
(function(SETTER_ACTIONS) {
    SETTER_ACTIONS[SETTER_ACTIONS["insert"] = 0] = "insert";
    SETTER_ACTIONS[SETTER_ACTIONS["remove"] = 1] = "remove";
    SETTER_ACTIONS[SETTER_ACTIONS["set"] = 2] = "set";
})(SETTER_ACTIONS || (SETTER_ACTIONS = {}));
export var CONTROL_ACTIONS;
(function(CONTROL_ACTIONS) {
    CONTROL_ACTIONS["command"] = "COMMAND";
    CONTROL_ACTIONS["reset"] = "RESET";
})(CONTROL_ACTIONS || (CONTROL_ACTIONS = {}));

//# sourceMappingURL=types.js.map